import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';

import { initialState } from './slice';

const selectDomain = (state?: RootState) => state?.formError || initialState;

export const selectFormError = createSelector([selectDomain], formError => formError);
